export const SETUP_PERPRO_SET_SELECTED_DEPARTMENT = 'SETUP_PERPRO_SELECTED_DEPARTMENT';
export const SETUP_PERPRO_SET_SELECTED_PERMISSION = 'SETUP_PERPRO_SET_SELECTED_PERMISSION';

export const SETUP_PERPRO_TOGGLE_DEPARTMENT_DIALOG = 'SETUP_PERPRO_TOGGLE_DEPARTMENT_DIALOG';

export const SETUP_PERPRO_SET_ALL_PERMISSIONS = 'SETUP_PERPRO_SET_ALL_PERMISSIONS';

export const SETUP_PERPRO_SET_EXPAND_KEYS = 'SETUP_PERPRO_SET_EXPAND_KEYS';



// WEBPACK FOOTER //
// ./src/views/Setup/PermissionProfile/flow/actionType.js